import classNames from 'classnames';
import React, { type CSSProperties, type JSX } from 'react';
import { useTranslation } from 'react-i18next';
import type { GroupBase, OptionProps, SingleValueProps } from 'react-select-modern';

import type { IThirdPartyDataOption } from '@feathr/blackbox';

import * as styles from './AffinityTargetingDataSelect.css';

export function DataOption<
  T extends IThirdPartyDataOption,
  IsMulti extends boolean = boolean,
  Group extends GroupBase<T> = GroupBase<T>,
>(props: Readonly<OptionProps<T, IsMulti, Group>>): JSX.Element {
  const { t } = useTranslation();
  const { data, innerProps, isFocused, isSelected, getStyles } = props;

  return (
    <div
      {...innerProps}
      className={classNames('react-select__option', {
        'react-select__option--is-focused': isFocused,
        'react-select__option--is-selected': isSelected,
      })}
      style={getStyles('option', props) as CSSProperties}
    >
      <div>
        <strong>{data.Name}</strong>
        <span> | </span>
        <span>{t('{{count, number}} Person', { count: data.ActiveIDsCount })}</span>
      </div>
      <div className={styles.path}>
        <p>{data.FullPath}</p>
        <p className={styles.description}>{data.Description}</p>
      </div>
    </div>
  );
}

export function DataSingleValue<
  T extends IThirdPartyDataOption,
  IsMulti extends boolean = boolean,
  Group extends GroupBase<T> = GroupBase<T>,
>(props: Readonly<SingleValueProps<T, IsMulti, Group>>): JSX.Element {
  const { t } = useTranslation();
  const { data, innerProps, getStyles } = props;

  return (
    <div
      {...innerProps}
      className={classNames('react-select__single-value', styles.single)}
      style={getStyles('singleValue', props) as CSSProperties}
    >
      <div>
        <strong>{data.Name}</strong>
        <span> | </span>
        <span>{t('{{count, number}} Person', { count: data.ActiveIDsCount })}</span>
      </div>
    </div>
  );
}
